/* rs-cookie-consent.js - behaviour for the consent dialog rendered by snippets/cookie-consent.liquid
   (design notes and the Customer Privacy API contract live in that snippet's header comment).
   launch readiness pass 2, 2026-09-24: moved out of the inline <script> block. Loaded with `defer` from the snippet, which sits at
   the end of <body>, so it still runs after the #cc-modal markup exists and before DOMContentLoaded - the same
   point in the page lifecycle as the inline version. No Liquid values are used. */
(function () {
  var modal = document.getElementById('cc-modal');
  if (!modal) return;
  var lastFocus = null;
  function focusable() {
    return [].slice.call(modal.querySelectorAll('a[href], button, input:not([disabled])'))
      .filter(function (el) { return el.offsetParent !== null; });
  }
  function open(e) {
    if (e) e.preventDefault();
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var f = modal.querySelector('.cc-modal__close');
    if (f) f.focus();
    modal.dispatchEvent(new CustomEvent('cc:opened'));
  }
  function close() {
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  // ---- Shopify Customer Privacy API ------------------------------------------------
  // cp stays null until the feature loads. Every handler tolerates that: if the API never
  // arrives we must NOT silently pretend consent was recorded, so the dialog stays put and
  // the buttons do nothing rather than closing on a false promise.
  var cp = null;

  var mkt = document.getElementById('cc-marketing');
  var ana = document.getElementById('cc-analytics');
  var status = modal.querySelector('[data-cc-status]');
  var apiFailed = false;

  // ---- Our own first-party record of the choice (Magebit #15, 2026-09-21) -----------------
  // EU testers (Chrome 140 incognito, Firefox) reported the dialog re-opening on every page and
  // the switches reading OFF after "Accept all" — i.e. Shopify's consent cookie did not persist
  // for them, while it does for a US visitor. Shopify's API remains the source of truth for
  // pixel gating; this cookie makes the dialog itself deterministic: once a choice is saved
  // here, we never auto-open again, we re-apply the choice to the platform if it comes back
  // blank, and we fill the switches from it. 1 year, Lax, first-party.
  var RS_COOKIE = 'rs_consent';
  function readOwn() {
    var m = document.cookie.match(new RegExp('(?:^|; )' + RS_COOKIE + '=([^;]*)'));
    if (!m) return null;
    try { return JSON.parse(decodeURIComponent(m[1])); } catch (e) { return null; }
  }
  function writeOwn(consent) {
    var v = encodeURIComponent(JSON.stringify({ a: consent.analytics ? 1 : 0, m: consent.marketing ? 1 : 0, t: Date.now() }));
    document.cookie = RS_COOKIE + '=' + v + '; max-age=31536000; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
  }
  function consentFor(a, m) {
    var c = { analytics: !!a, marketing: !!m, preferences: !!a };
    // sale_of_data is a US-state purpose; only send it where Shopify has a data-sale region configured.
    if (cp && typeof cp.saleOfDataRegion === 'function' && cp.saleOfDataRegion()) c.sale_of_data = !!m;
    return c;
  }

  function say(msg, isError) {
    if (!status) return;
    status.textContent = msg || '';
    status.hidden = !msg;
    status.classList.toggle('cc-status--error', !!isError);
  }
  function apiUnavailable() {
    // The dialog must never imply a choice was recorded when the platform API is absent.
    apiFailed = true;
    [mkt, ana].forEach(function (el) { if (el) el.disabled = true; });
    say('Cookie settings cannot be loaded right now. Your current choices are unchanged. Please reload the page to try again.', true);
  }

  function reflectSavedConsent() {
    if (!cp || !cp.currentVisitorConsent) return;
    var c = cp.currentVisitorConsent() || {};
    var own = readOwn();
    var platformAnswered = c.marketing === 'yes' || c.marketing === 'no' || c.analytics === 'yes' || c.analytics === 'no';
    if (!platformAnswered && own) {
      // The platform forgot but we remember: show our record and quietly re-apply it.
      if (mkt) mkt.checked = !!own.m;
      if (ana) ana.checked = !!own.a;
      if (cp.setTrackingConsent) cp.setTrackingConsent(consentFor(own.a, own.m), function (err) {
        if (err && err.error) console.warn('[rs-consent] re-apply failed', err);
      });
      return;
    }
    // Values are 'yes' / 'no' / '' (never asked). Anything but 'yes' stays off.
    if (mkt) mkt.checked = c.marketing === 'yes';
    if (ana) ana.checked = c.analytics === 'yes';
  }

  var saving = false;
  function saveConsent(consent, done) {
    if (!cp || !cp.setTrackingConsent) { apiUnavailable(); return; }
    if (saving) return;
    saving = true;
    say('Saving your choice…');
    cp.setTrackingConsent(consent, function (err) {
      saving = false;
      // Shopify passes an error object on failure. Do NOT close on failure: closing would read
      // as "saved". The visitor keeps the dialog, sees why, and can retry or close with the X.
      if (err && err.error) { console.warn('[rs-consent] setTrackingConsent failed', err); say('Your choice could not be saved. Please try again.', true); return; }
      writeOwn(consent);
      say('');
      if (typeof done === 'function') done();
    });
  }

  function acceptAll() { saveConsent(consentFor(true, true), close); }
  function declineAll() { saveConsent(consentFor(false, false), close); }
  function savePreferences() {
    var m = !!(mkt && mkt.checked);
    var a = !!(ana && ana.checked);
    // preferences ride with analytics: this dialog exposes no separate control for it, and
    // claiming a purpose the visitor was never shown would be the same lie as the old banner.
    // sale_of_data follows marketing -- that is the CPRA-relevant purpose here.
    saveConsent(consentFor(a, m), close);
  }

  // Open from any [data-cc-open] trigger (e.g. footer "Manage Cookies" link)
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cc-open]')) { open(e); return; }
    if (e.target.closest('[data-cc-noop]')) { e.preventDefault(); return; }
    if (e.target.closest('[data-cc-accept]')) { acceptAll(); return; }
    if (e.target.closest('[data-cc-decline]')) { declineAll(); return; }
    if (e.target.closest('[data-cc-save]')) { savePreferences(); return; }
    if (e.target.closest('[data-cc-close]')) { close(); }
  });

  // Load the consent API, then decide whether this visitor must be asked. shouldShowBanner()
  // reflects Settings -> Customer privacy: with no region configured it is false everywhere and
  // this dialog stays closed until the footer link is used. That is correct, not broken.
  // If the dialog is opened (footer link) before the API has arrived, give it a few seconds and
  // then say so rather than leaving switches that silently do nothing.
  // Final audit 2026-10-18: the dialog opened in the disabled 'cannot be loaded' state in 2 of 3 runs even
  // though window.Shopify.customerPrivacy was present - `cp` was only ever set inside the loadFeatures
  // callback, which can fire before this script, or never when another script loaded the feature first,
  // and the 4 s timer then made apiFailed sticky. adoptApi() takes the API from wherever it appears
  // (callback or poll) and REVERSES the failed state: switches back on, status cleared, saved consent
  // reflected, auto-open evaluated. The poll gives up after 10 s.
  function adoptApi() {
    if (cp || !window.Shopify || !window.Shopify.customerPrivacy) return !!cp;
    cp = window.Shopify.customerPrivacy;
    apiFailed = false;
    [mkt, ana].forEach(function (el) { if (el) el.disabled = false; });
    say('');
    reflectSavedConsent();
    // This dialog IS the prompt (Shopify's own banner is off in Settings -> Customer privacy, the two are
    // mutually exclusive). Auto-open only when the platform says unanswered AND we hold no record either.
    if (typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner() && !readOwn()) open();
    return true;
  }
  var cpPolls = 0;
  var cpTimer = window.setInterval(function () { cpPolls += 1; if (adoptApi() || cpPolls > 40) window.clearInterval(cpTimer); }, 250);
  modal.addEventListener('cc:opened', function () {
    if (cp || apiFailed) return;
    window.setTimeout(function () { if (!cp && !apiFailed) apiUnavailable(); }, 6000);
  });
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error || !window.Shopify.customerPrivacy) { if (!cp) apiUnavailable(); return; }
        adoptApi();
      }
    );
  } else {
    apiUnavailable();
  }
  // Keep keyboard focus inside the dialog while open; Esc closes it
  modal.addEventListener('keydown', function (e) {
    if (modal.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var els = focusable();
    if (!els.length) return;
    var first = els[0], last = els[els.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();
